import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IModuleBalances } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getModuleBalancesConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_module_balances', timeframe)) as IModuleBalances[]
	const series1 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.POOL_MODULE_BALANCE }
	})
	const series2 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BOND_MODULE_BALANCE }
	})
	const series3 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RESERVE_MODULE_BALANCE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'Pool Module',
			type: 'line',
			seriesGroup: '[rune]',
			color: 'orange',
			unitSymbol: 'ᚱ'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'Bond Module',
			type: 'line',
			seriesGroup: '[rune]',
			color: 'green',
			unitSymbol: 'ᚱ'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'Reserve Module',
			type: 'line',
			seriesGroup: '[rune]',
			color: `${color}`,
			unitSymbol: 'ᚱ'
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const ModuleBalances = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getModuleBalancesConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Module Balances"
			chartDesc="Balances held in various THORChain modules. Provides visibility into internal protocol fund allocation."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="b36f1290-e971-4dfc-84b7-792674bf63c4"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={true}
			sortByValueDesc={true}
		/>
	)
}

export default ModuleBalances
